import { createWebHistory, createRouter } from "vue-router";
import Login from "@/pages/users/Login.vue";
import LoginSuperAdmin from "@/pages/users/LoginSuperAdmin";

import Overview from "@/pages/dashboard/Overview.vue";
import SoldOut from "@/pages/dashboard/SoldOut.vue";
import XReport from "@/pages/reports/XReport.vue";
import ZReport from "@/pages/reports/ZReport.vue";
import TurnoverReport from "@/pages/reports/TurnoverReport.vue";
import AlcoholReport from "@/pages/reports/AlcoholReport.vue";
import CashHoldingReport from "@/pages/reports/CashHoldingReport.vue";
import SMSReport from "@/pages/reports/SMSReport.vue";
import KitchenTimesReport from "@/pages/reports/KitchenTimesReport.vue";
import SAFTReport from "@/pages/reports/SAFTReport.vue";
import AccountingVouchers from "@/pages/reports/AccountingVouchers.vue";
import SAFTUploadReport from "@/pages/reports/SAFTUploadReport.vue";
import GenerateEventReports from "@/pages/reports/GenerateEventReports.vue";
import TransactionsReport from "@/pages/reports/TransactionsReport.vue";
import XReportRegenerate from "@/pages/reports/XReportRegenerate.vue";
import WebshopXReportRegenerateAll from "@/pages/reports/WebshopXReportRegenerateAll.vue";

import Orders from "@/pages/orders/Orders.vue";
import OrderDetail from "@/pages/orders/OrderDetail.vue";
import OrderRefund from "@/pages/orders/OrderRefund.vue";
import WebOrderRefund from "@/pages/webview/WebOrderRefund.vue";
import SoftpayOrderRefund from "@/pages/webview/SoftpayOrderRefund.vue";
import CashOrderRefund from "@/pages/webview/CashOrderRefund.vue";
import CashAndCardOrderRefund from "@/pages/webview/CashAndCardOrderRefund.vue";
import PayMyPartOrderRefund from "@/pages/webview/PayMyPartOrderRefund.vue";
import VivaOrderRefund from "@/pages/webview/VivaOrderRefund.vue";
import VivaCashAndCardOrderRefund from "@/pages/webview/VivaCashAndCardOrderRefund.vue";
import VivaPayMyPartOrderRefund from "@/pages/webview/VivaPayMyPartOrderRefund.vue";

import Products from "@/pages/products/Products.vue";
import CategoryCreate from "@/pages/products/CategoryCreate.vue";
import CategoryEdit from "@/pages/products/CategoryEdit.vue";
import AddOnGroupCreate from "@/pages/products/AddOnGroupCreate.vue";
import AddOnGroupEdit from "@/pages/products/AddOnGroupEdit.vue";
import AddOnCreate from "@/pages/products/AddOnCreate.vue";
import AddOnEdit from "@/pages/products/AddOnEdit.vue";
import CategoriesSort from "@/pages/products/CategoriesSort.vue";
import ItemCreate from "@/pages/products/ItemCreate.vue";
import ItemEdit from "@/pages/products/ItemEdit.vue";
import ItemsOfCategorySort from "@/pages/products/ItemsOfCategorySort.vue";
import AddOnGroupsSort from "@/pages/products/AddOnGroupsSort.vue";
import AddOnsOfAddOnGroupSort from "@/pages/products/AddOnsOfAddOnGroupSort.vue";

import Users from "@/pages/users/Users.vue";
import UserCreate from "@/pages/users/UserCreate.vue";
import UserEdit from "@/pages/users/UserEdit.vue";

import Terminals from "@/pages/terminals/Terminals.vue";

import Discounts from "@/pages/loyalty/Discounts.vue";
import DiscountCreate from "@/pages/loyalty/DiscountCreate.vue";
import DiscountEdit from "@/pages/loyalty/DiscountEdit.vue";
import Rewards from "@/pages/loyalty/Rewards.vue";
import RewardCreate from "@/pages/loyalty/RewardCreate.vue";
import RewardEdit from "@/pages/loyalty/RewardEdit.vue";

import OpeningHours from "@/pages/settings/OpeningHours.vue";

import Tables from "@/pages/tables/Tables.vue";
import Bookings from "@/pages/booking/Bookings.vue";
import BookingSettings from "@/pages/booking/BookingSettings.vue";
import TableCreate from "@/pages/tables/TableCreate.vue";

import Delivery from "@/pages/settings/Delivery.vue";
import ClosingDays from "@/pages/settings/ClosingDays.vue";
import ClosingDaysCreate from "@/pages/settings/ClosingDaysCreate.vue";
import Announcements from "@/pages/settings/Announcements.vue";
import AnnouncementCreate from "@/pages/settings/AnnouncementCreate.vue";
import CloseOnline from "@/pages/settings/CloseOnline.vue";
import OpenOnline from "@/pages/settings/OpenOnline.vue";
import ChangeEarliestPickupTime from "@/pages/settings/ChangeEarliestPickupTime.vue";
import CloseDishes from "@/pages/settings/CloseDishes.vue";
import OpenDishes from "@/pages/settings/OpenDishes.vue";
import Vat from "@/pages/settings/Vat.vue";
import VatEdit from "@/pages/settings/VatEdit.vue";
import Company from "@/pages/settings/Company.vue";
import SiteEditor from "@/pages/settings/SiteEditor.vue";
import CustomDomain from "@/pages/settings/CustomDomain.vue";
import VivaOnboarding from "@/pages/settings/VivaOnboarding.vue";
import Billing from "@/pages/settings/Billing.vue";
import Locations from "@/pages/settings/Locations.vue";
import LocationCreate from "@/pages/settings/LocationCreate.vue";
import LocationEdit from "@/pages/settings/LocationEdit.vue";
import OdsDisplays from "@/pages/settings/OdsDisplays.vue";
import SendIncidentSMS from "@/pages/settings/SendIncidentSMS.vue";
import SwedbankPay from "@/pages/settings/SwedbankPay.vue";
import SwedbankPayTransactions from "@/pages/system/SwedbankPayTransactions.vue";
import DinteroTransactions from "@/pages/system/DinteroTransactions.vue";
import StoreVivaAccount from "@/pages/system/StoreVivaAccount.vue";
import Merchants from "@/pages/system/Merchants.vue";
import SyncGatewayUsers from "@/pages/system/SyncGatewayUsers.vue";
import AggregatedTurnoverReport from "@/pages/system/AggregatedTurnoverReport.vue";
import Mdm from "@/pages/system/Mdm.vue";
import MdmPolicies from "@/pages/system/MdmPolicies.vue";
import MdmEnroll from "@/pages/system/MdmEnroll.vue";
import MdmApps from "@/pages/system/MdmApps.vue";
import AmapiConfig from "@/pages/system/AmapiConfig.vue";
import S3Config from "@/pages/system/S3Config.vue";
import BringConfig from "@/pages/system/BringConfig.vue";
import UnimicroConfig from "@/pages/system/UnimicroConfig.vue";
import SubscriptionConfig from "@/pages/system/SubscriptionConfig.vue";
import RustdeskConfig from "@/pages/system/RustdeskConfig.vue";
import VivaPartnerConfig from "@/pages/system/VivaPartnerConfig.vue";
import ServiceAccounts from "@/pages/system/ServiceAccounts.vue";
import SmtpConfig from "@/pages/system/SmtpConfig.vue";
import VivaConfig from "@/pages/system/VivaConfig.vue";
import DinteroConfig from "@/pages/system/DinteroConfig.vue";
import SiteModelConfig from "@/pages/system/SiteModelConfig.vue";
import VivaTransactions from "@/pages/system/VivaTransactions.vue";
import VivaPaymentTransactions from "@/pages/system/VivaPaymentTransactions.vue";
import VivaPayoutReports from "@/pages/system/VivaPayoutReports.vue";
import Dintero from "@/pages/settings/Dintero.vue";
import Merchant from "@/pages/settings/Merchant.vue";
import Tripletex from "@/pages/settings/Tripletex.vue";
import TripletexSyncZReport from "@/pages/settings/TripletexSyncZReport.vue";
import TripletexDeleteVouchers from "@/pages/settings/TripletexDeleteVouchers.vue";
import TripletexSyncSettlements from "@/pages/settings/TripletexSyncSettlements.vue";
import TripletexSyncOrders from "@/pages/settings/TripletexSyncOrders.vue";
import TripletexSyncProducts from "@/pages/settings/TripletexSyncProducts.vue";
import TripletexAccountSettings from "@/pages/settings/TripletexAccountSettings.vue";
import Unimicro from "@/pages/settings/Unimicro.vue";
import UnimicroAccountSettings from "@/pages/settings/UnimicroAccountSettings.vue";
import UnimicroSyncZReport from "@/pages/settings/UnimicroSyncZReport.vue";
import UnimicroDeleteVouchers from "@/pages/settings/UnimicroDeleteVouchers.vue";
import TripletexDepartments from "@/pages/settings/TripletexDepartments.vue";
import UnimicroSyncOrders from "@/pages/settings/UnimicroSyncOrders.vue";
import UnimicroDepartments from "@/pages/settings/UnimicroDepartments.vue";
import Fiken from "@/pages/settings/Fiken.vue";
import FikenAccountSettings from "@/pages/settings/FikenAccountSettings.vue";
import FikenSyncZReport from "@/pages/settings/FikenSyncZReport.vue";
import FikenSyncOrders from "@/pages/settings/FikenSyncOrders.vue";
import FikenDeleteVouchers from "@/pages/settings/FikenDeleteVouchers.vue";
import FikenCompanies from "@/pages/settings/FikenCompanies.vue";
import InvoiceCustomers from "@/pages/settings/InvoiceCustomers.vue";
import CloudPRNT from "@/pages/system/CloudPRNT.vue";

import Cache from "@/pages/system/Cache.vue";
import SmartPickupTimeInsight from "@/pages/system/SmartPickupTimeInsight.vue";

import BusinessAnalytics from "@/pages/analytics/BusinessAnalytics.vue";
import HelpVideo from "@/pages/support/HelpVideo.vue";
import Bokettersyn from "@/pages/support/Bokettersyn.vue";
import POSUserGuide from "@/pages/support/POSUserGuide.vue";
import BackofficeUserGuide from "@/pages/support/BackofficeUserGuide.vue";
import Terms from "@/pages/support/Terms.vue";
import Privacy from "@/pages/support/Privacy.vue";
import Dpa from "@/pages/support/Dpa.vue";

const Profile = () => import("@/pages/users/Profile.vue") //lazy-loaded

const routes = [
   {
     path: "/",
     name: "overview",
     component: Overview
   },
   {
     path: "/overview",
     component: Overview
   },
    {
        path: "/soldOut",
        name: "soldOut",
        component: SoldOut
    },
   {
     path: "/login",
     component: Login
   },
    {
        path: "/superadmin/login",
        component: LoginSuperAdmin
    },
   {
     path: "/profile",
     name: "profile",
     component: Profile
    },
    {
        path: "/x-report",
        name: "x-report",
        component: XReport
    },
    {
        path: "/z-report",
        name: "z-report",
        component: ZReport
    },
    {
        path: "/totalSalesReport",
        name: "totalSalesReport",
        component: TurnoverReport
    },
    {
        path: "/alcoholReport",
        name: "alcoholReport",
        component: AlcoholReport
    },
    {
        path: "/cashHoldingReport",
        name: "cashHoldingReport",
        component: CashHoldingReport
    },
    {
        path: "/smsReport",
        name: "smsReport",
        component: SMSReport
    },
    {
        path: "/kitchenTimesReport",
        name: "kitchenTimesReport",
        component: KitchenTimesReport
    },
    {
        path: "/saftReport",
        name: "saftReport",
        component: SAFTReport
    },
    {
        path: "/accountingVouchers",
        name: "accountingVouchers",
        component: AccountingVouchers
    },
    {
        path: "/saftUploadReport",
        name: "saftUploadReport",
        component: SAFTUploadReport
    },
    {
        path: "/generateEventReports",
        name: "generateEventReports",
        component: GenerateEventReports
    },
    {
        path: "/transactionsReport",
        name: "transactionsReport",
        component: TransactionsReport
    },
    {
        path: "/xReportRegenerate",
        name: "xReportRegenerate",
        component: XReportRegenerate
    },
    {
        path: "/webshopXReportRegenerateAll",
        name: "webshopXReportRegenerateAll",
        component: WebshopXReportRegenerateAll
    },
    {
        path: "/orders",
        name: "orders",
        component: Orders
    },
    {
        path: "/orderDetail",
        name: "orderDetail",
        component: OrderDetail
    },
    {
        path: "/orderRefund",
        name: "orderRefund",
        component: OrderRefund
    },
    {
        path: "/webOrderRefund",        /* used in POS */
        name: "webOrderRefund",
        component: WebOrderRefund
    },
    {
        path: "/softpayOrderRefund",    /* used in POS */
        name: "softpayOrderRefund",
        component: SoftpayOrderRefund
    },
    {
        path: "/cashOrderRefund",    /* used in POS */
        name: "cashOrderRefund",
        component: CashOrderRefund
    },
    {
        path: "/cashAndCardOrderRefund",    /* used in POS */
        name: "cashAndCardOrderRefund",
        component: CashAndCardOrderRefund
    },
    {
        path: "/payMyPartOrderRefund",    /* used in POS */
        name: "payMyPartOrderRefund",
        component: PayMyPartOrderRefund
    },
    {
        path: "/vivaOrderRefund",    /* used in POS for Viva payments */
        name: "vivaOrderRefund",
        component: VivaOrderRefund
    },
    {
        path: "/vivaCashAndCardOrderRefund",    /* used in POS for Viva + cash payments */
        name: "vivaCashAndCardOrderRefund",
        component: VivaCashAndCardOrderRefund
    },
    {
        path: "/vivaPayMyPartOrderRefund",    /* used in POS for Viva pay-my-part */
        name: "vivaPayMyPartOrderRefund",
        component: VivaPayMyPartOrderRefund
    },
    // The same two refund pages, opened from Backoffice by SUPER_ADMIN for a till or kiosk VIVA payment:
    // they keep Backoffice's navigation and refund through /api/superadmin/payment/vivaTerminalRefund,
    // which also books the refund on the till (grand total of returns, electronic journal).
    {
        path: "/vivaTerminalRefund",
        name: "vivaTerminalRefund",
        component: VivaOrderRefund,
        props: { backoffice: true }
    },
    {
        path: "/vivaTerminalPayMyPartRefund",
        name: "vivaTerminalPayMyPartRefund",
        component: VivaPayMyPartOrderRefund,
        props: { backoffice: true }
    },
    {
        path: "/products",
        name: "products",
        component: Products
    },
    {
        path: "/categoryCreate",
        name: "categoryCreate",
        component: CategoryCreate
    },
    {
        path: "/categoryEdit",
        name: "categoryEdit",
        component: CategoryEdit
    },
    {
        path: "/categoriesSort",
        name: "categoriesSort",
        component: CategoriesSort
    },
    {
        path: "/itemCreate",
        name: "itemCreate",
        component: ItemCreate
    },
    {
        path: "/itemEdit",
        name: "itemEdit",
        component: ItemEdit
    },
    {
        path: "/itemsOfCategorySort",
        name: "itemsOfCategorySort",
        component: ItemsOfCategorySort
    },
    {
        path: "/addOnGroupsSort",
        name: "addOnGroupsSort",
        component: AddOnGroupsSort
    },
    {
        path: "/addOnsOfAddOnGroupSort",
        name: "addOnsOfAddOnGroupSort",
        component: AddOnsOfAddOnGroupSort
    },
    {
        path: "/addOnGroupCreate",
        name: "addOnGroupCreate",
        component: AddOnGroupCreate
    },
    {
        path: "/addOnGroupEdit",
        name: "addOnGroupEdit",
        component: AddOnGroupEdit
    },
    {
        path: "/addOnCreate",
        name: "addOnCreate",
        component: AddOnCreate
    },
    {
        path: "/addOnEdit",
        name: "addOnEdit",
        component: AddOnEdit
    },
    {
        path: "/users",
        name: "users",
        component: Users
    },
    {
        path: "/userCreate",
        name: "userCreate",
        component: UserCreate
    },
    {
        path: "/userEdit",
        name: "userEdit",
        component: UserEdit
    },
    {
        path: "/terminals",
        name: "terminals",
        component: Terminals
    },
    {
        path: "/rewards",
        name: "rewards",
        component: Rewards
    },
    {
        path: "/rewardCreate",
        name: "rewardCreate",
        component: RewardCreate
    },
    {
        path: "/rewardEdit",
        name: "rewardEdit",
        component: RewardEdit
    },
    {
        path: "/discounts",
        name: "discounts",
        component: Discounts
    },
    {
        path: "/discountCreate",
        name: "discountCreate",
        component: DiscountCreate
    },
    {
        path: "/discountEdit",
        name: "discountEdit",
        component: DiscountEdit
    },
    {
        path: "/openinghours",
        name: "openinghours",
        component: OpeningHours
    },
    {
        path: "/tables",
        name: "tables",
        component: Tables
    },
    {
        path: "/tableCreate",
        name: "tableCreate",
        component: TableCreate
    },
    {
        path: "/delivery",
        name: "delivery",
        component: Delivery
    },
    {
        path: "/bookings",
        name: "bookings",
        component: Bookings
    },
    {
        path: "/bookingSettings",
        name: "bookingSettings",
        component: BookingSettings
    },
    {
        path: "/closingdays",
        name: "closingdays",
        component: ClosingDays
    },
    {
        path: "/closingDaysCreate",
        name: "closingDaysCreate",
        component: ClosingDaysCreate
    },
    {
        path: "/announcements",
        name: "announcements",
        component: Announcements
    },
    {
        path: "/announcementCreate",
        name: "announcementCreate",
        component: AnnouncementCreate
    },
    {
        path: "/closeOnline",
        name: "closeOnline",
        component: CloseOnline
    },
    {
        path: "/openOnline",
        name: "openOnline",
        component: OpenOnline
    },
    {
        path: "/changeEarliestPickupTime",
        name: "changeEarliestPickupTime",
        component: ChangeEarliestPickupTime
    },
    {
        path: "/closeDishes",
        name: "closeDishes",
        component: CloseDishes
    },
    {
        path: "/openDishes",
        name: "openDishes",
        component: OpenDishes
    },
    {
        path: "/vat",
        name: "vat",
        component: Vat
    },
    {
        path: "/vatEdit",
        name: "vatEdit",
        component: VatEdit
    },
    {
        path: "/company",
        name: "company",
        component: Company
    },
    {
        // Website Builder: the common entry for both halves of the merchant's website. It keeps the
        // path it always had, because the onboarding checklist, the training material and every link
        // ever sent to a merchant already point here.
        path: "/siteBuilder",
        name: "siteBuilder",
        component: SiteEditor
    },
    {
        path: "/customDomain",
        name: "customDomain",
        component: CustomDomain
    },
    {
        path: "/vivaOnboarding",
        name: "vivaOnboarding",
        component: VivaOnboarding
    },
    {
        path: "/billing",
        name: "billing",
        component: Billing
    },
    {
        path: "/locations",
        name: "locations",
        component: Locations
    },
    {
        path: "/locationCreate",
        name: "locationCreate",
        component: LocationCreate
    },
    {
        path: "/locationEdit",
        name: "locationEdit",
        component: LocationEdit
    },
    {
        path: "/odsDisplays",
        name: "odsDisplays",
        component: OdsDisplays
    },
    {
        path: "/sendIncidentSMS",
        name: "sendIncidentSMS",
        component: SendIncidentSMS
    },
    {
        path: "/swedbankPay",
        name: "swedbankPay",
        component: SwedbankPay
    },
    {
        path: "/swedbankPayTransactions",
        name: "swedbankPayTransactions",
        component: SwedbankPayTransactions
    },
    {
        path: "/dintero",
        name: "dintero",
        component: Dintero
    },
    {
        path: "/dinteroTransactions",
        name: "dinteroTransactions",
        component: DinteroTransactions
    },
    {
        path: "/storeVivaAccount",
        name: "storeVivaAccount",
        component: StoreVivaAccount
    },
    {
        path: "/merchants",
        name: "merchants",
        component: Merchants
    },
    {
        path: "/syncGatewayUsers",
        name: "syncGatewayUsers",
        component: SyncGatewayUsers
    },
    {
        path: "/aggregatedTurnoverReport",
        name: "aggregatedTurnoverReport",
        component: AggregatedTurnoverReport
    },
    {
        path: "/mdm",
        name: "mdm",
        component: Mdm
    },
    {
        path: "/mdmPolicies",
        name: "mdmPolicies",
        component: MdmPolicies
    },
    {
        path: "/mdmEnroll",
        name: "mdmEnroll",
        component: MdmEnroll
    },
    {
        path: "/mdmApps",
        name: "mdmApps",
        component: MdmApps
    },
    {
        path: "/amapiConfig",
        name: "amapiConfig",
        component: AmapiConfig
    },
    {
        path: "/s3Config",
        name: "s3Config",
        component: S3Config
    },
    {
        path: "/bringConfig",
        name: "bringConfig",
        component: BringConfig
    },
    {
        path: "/unimicroConfig",
        name: "unimicroConfig",
        component: UnimicroConfig
    },
    {
        path: "/subscriptionConfig",
        name: "subscriptionConfig",
        component: SubscriptionConfig
    },
    {
        path: "/rustdeskConfig",
        name: "rustdeskConfig",
        component: RustdeskConfig
    },
    {
        path: "/vivaPartnerConfig",
        name: "vivaPartnerConfig",
        component: VivaPartnerConfig
    },
    {
        path: "/serviceAccounts",
        name: "serviceAccounts",
        component: ServiceAccounts
    },
    {
        path: "/smtpConfig",
        name: "smtpConfig",
        component: SmtpConfig
    },
    {
        path: "/vivaConfig",
        name: "vivaConfig",
        component: VivaConfig
    },
    {
        path: "/dinteroConfig",
        name: "dinteroConfig",
        component: DinteroConfig
    },
    {
        path: "/siteModelConfig",
        name: "siteModelConfig",
        component: SiteModelConfig
    },
    {
        path: "/vivaTransactions",
        name: "vivaTransactions",
        component: VivaTransactions
    },
    {
        path: "/vivaPaymentTransactions",
        name: "vivaPaymentTransactions",
        component: VivaPaymentTransactions
    },
    {
        path: "/vivaPayoutReports",
        name: "vivaPayoutReports",
        component: VivaPayoutReports
    },
    {
        path: "/merchant",
        name: "merchant",
        component: Merchant
    },
    {
        path: "/tripletex",
        name: "tripletex",
        component: Tripletex
    },
    {
        path: "/tripletexSyncZReport",
        name: "tripletexSyncZReport",
        component: TripletexSyncZReport
    },
    {
        path: "/tripletexDeleteVouchers",
        name: "tripletexDeleteVouchers",
        component: TripletexDeleteVouchers
    },
    {
        path: "/tripletexSyncSettlements",
        name: "tripletexSyncSettlements",
        component: TripletexSyncSettlements
    },
    {
        path: "/tripletexSyncOrders",
        name: "tripletexSyncOrders",
        component: TripletexSyncOrders
    },
    {
        path: "/tripletexSyncProducts",
        name: "tripletexSyncProducts",
        component: TripletexSyncProducts
    },
    {
        path: "/tripletexAccountSettings",
        name: "tripletexAccountSettings",
        component: TripletexAccountSettings
    },
    {
        path: "/unimicro",
        name: "unimicro",
        component: Unimicro
    },
    {
        path: "/unimicroAccountSettings",
        name: "unimicroAccountSettings",
        component: UnimicroAccountSettings
    },
    {
        path: "/unimicroSyncZReport",
        name: "unimicroSyncZReport",
        component: UnimicroSyncZReport
    },
    {
        path: "/unimicroSyncOrders",
        name: "unimicroSyncOrders",
        component: UnimicroSyncOrders
    },
    {
        path: "/unimicroDeleteVouchers",
        name: "unimicroDeleteVouchers",
        component: UnimicroDeleteVouchers
    },
    {
        path: "/tripletexDepartments",
        name: "tripletexDepartments",
        component: TripletexDepartments
    },
    {
        path: "/unimicroDepartments",
        name: "unimicroDepartments",
        component: UnimicroDepartments
    },
    {
        path: "/fiken",
        name: "fiken",
        component: Fiken
    },
    {
        path: "/fikenAccountSettings",
        name: "fikenAccountSettings",
        component: FikenAccountSettings
    },
    {
        path: "/fikenSyncZReport",
        name: "fikenSyncZReport",
        component: FikenSyncZReport
    },
    {
        path: "/fikenSyncOrders",
        name: "fikenSyncOrders",
        component: FikenSyncOrders
    },
    {
        path: "/fikenDeleteVouchers",
        name: "fikenDeleteVouchers",
        component: FikenDeleteVouchers
    },
    {
        path: "/fikenCompanies",
        name: "fikenCompanies",
        component: FikenCompanies
    },
    {
        path: "/invoiceCustomers",
        name: "invoiceCustomers",
        component: InvoiceCustomers
    },
    {
        path: "/bokettersyn",
        name: "bokettersyn",
        component: Bokettersyn
    },
    {
        path: "/terms",
        name: "terms",
        component: Terms
    },
    {
        path: "/privacy",
        name: "privacy",
        component: Privacy
    },
    {
        path: "/dpa",
        name: "dpa",
        component: Dpa
    },
    {
        path: "/helpvideo",
        name: "helpvideo",
        component: HelpVideo
    },
    {
        path: "/posuserguide",
        name: "posUserGuide",
        component: POSUserGuide
    },
    {
        path: "/backofficeuserguide",
        name: "backofficeUserGuide",
        component: BackofficeUserGuide
    },
    {
        path: "/cloudprnt",
        name: "cloudprnt",
        component: CloudPRNT
    },
    {
        path: "/cache",
        name: "cache",
        component: Cache
    },
    {
        path: "/smartPickupTimeInsight",
        name: "smartPickupTimeInsight",
        component: SmartPickupTimeInsight
    },
    {
        path: "/analytics",
        name: "analytics",
        component: BusinessAnalytics
    }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

router.beforeEach((to, from, next) => {
   const publicPages = ['/login', '/superadmin/login'];
   const authRequired = !publicPages.includes(to.path);
   const loggedIn = localStorage.getItem('user');

   //Trying to access a restricted page + not logged in, redirect to login page.
   if (authRequired && !loggedIn) {
     next('/login');
   } else if (!authRequired && loggedIn) {
     // A signed-in user who reaches a login page — back button, an old bookmark, a typed address — is
     // sent to Oversikt, and their session is left alone. The ONLY way to sign in as somebody else is to
     // sign out first, which is the explicit path and the one people expect.
     //
     // History, because this has been both ways: the login pages used to redirect like this, then were
     // changed to END the session on arrival, because a SUPER_ADMIN switching from a merchant session
     // got bounced back into the old one without noticing. That fix made every stray visit to /login
     // a logout — and with two tabs on the form, signing in on one revoked the other's token within
     // the second (2026-09-19). Redirecting here, before the page mounts, keeps the switch case
     // unambiguous (log out, then log in) without turning the back button into a logout.
     next('/');
   } else if (loggedIn) {
     const user = JSON.parse(loggedIn);

     // SaaS features (Website Builder, VIVA-onboarding, Abonnement og betaling) are gated per merchant
     // via merchant_setting.useSaaSFeatures — legacy merchants (field missing/false) must not reach them
     // even by direct URL (e.g. saving a site theme would override a legacy design). SUPER_ADMIN passes.
     // Every page below is backed ONLY by /api/superadmin/** endpoints, so anyone else reaching one by
     // URL gets a form where every call 403s — which reads as a broken page rather than as "no access".
     // That is exactly how it presented: /amapiConfig rendered for a merchant ADMIN, the config never
     // loaded, and the Lagre button looked dead (2026-08-29). The menu already hides these behind
     // v-if="isSuperAdmin", but a typed address or a tab left open from an earlier SUPER_ADMIN session
     // walks straight past that. The server is the real guard; this only stops the misleading screen.
     const superAdminOnlyPaths = [
       // MDM / device management
       '/mdm', '/mdmPolicies', '/mdmEnroll', '/mdmApps', '/amapiConfig',
       // System → Config
       '/vivaPartnerConfig', '/vivaConfig', '/dinteroConfig', '/siteModelConfig', '/bringConfig', '/unimicroConfig',
       '/smtpConfig', '/subscriptionConfig', '/rustdeskConfig', '/serviceAccounts',
       '/storeVivaAccount',
       // System → Diverse
       '/merchants', '/syncGatewayUsers', '/cache', '/aggregatedTurnoverReport',
       '/smartPickupTimeInsight',
       // Refunding a till or kiosk VIVA payment from Backoffice
       '/vivaTerminalRefund', '/vivaTerminalPayMyPartRefund',
       // Making a past day's Z again: it deletes that day's Z first. The server refuses anyone else (2026-10-28).
       '/xReportRegenerate', '/webshopXReportRegenerateAll'
       // Regnskapsbilag was here while tested in production (2026-10-24 – 2026-11-01). It is the merchant's ADMIN and
       // ACCOUNTANT's now: employeeRestrictedPaths and accountantAllowedPaths below decide.
     ];
     if (superAdminOnlyPaths.includes(to.path) && user.userRole !== 'SUPER_ADMIN') {
       next('/overview');
       return;
     }

     const saasOnlyPaths = ['/siteBuilder', '/vivaOnboarding', '/billing', '/odsDisplays'];
     if (saasOnlyPaths.includes(to.path) && user.userRole !== 'SUPER_ADMIN'
         && !(user.merchantSetting && user.merchantSetting.useSaaSFeatures === true)) {
       next('/overview');
       return;
     }

     if (user.userRole === 'EMPLOYEE') {
       const employeeRestrictedPaths = [
         // User management
         '/users', '/userCreate', '/userEdit',
         // Loyalty
         '/discounts', '/discountCreate', '/discountEdit',
         '/rewards', '/rewardCreate', '/rewardEdit',
         // Settings
         '/company', '/siteBuilder', '/vivaOnboarding', '/billing', '/odsDisplays', '/vat', '/vatEdit', '/delivery', '/openinghours', '/bookingSettings',
         '/closeDishes', '/openDishes',
         '/locations', '/locationCreate', '/locationEdit', '/sendIncidentSMS',
         '/swedbankPay', '/swedbankPayTransactions', '/dintero', '/dinteroTransactions', '/vivaTransactions', '/merchant', '/tripletex',
         '/tripletexSyncZReport', '/tripletexDeleteVouchers',
         '/tripletexSyncSettlements', '/tripletexSyncOrders', '/tripletexSyncProducts', '/tripletexAccountSettings',
         '/unimicro', '/unimicroAccountSettings',
         '/unimicroSyncZReport', '/unimicroSyncOrders', '/unimicroDeleteVouchers', '/unimicroDepartments',
         '/fiken', '/fikenAccountSettings',
         '/fikenSyncZReport', '/fikenSyncOrders', '/fikenDeleteVouchers', '/fikenCompanies',
         '/tripletexDepartments',
         '/invoiceCustomers',
         '/terminals', '/tables', '/tableCreate',
         // Product write routes
         '/categoryCreate', '/categoryEdit', '/categoriesSort',
         '/itemCreate', '/itemEdit', '/itemsOfCategorySort',
         '/addOnGroupCreate', '/addOnGroupEdit', '/addOnGroupsSort',
         '/addOnCreate', '/addOnEdit', '/addOnsOfAddOnGroupSort',
         // Order write routes
         '/orderRefund',
         // Reports
         '/x-report', '/z-report', '/totalSalesReport', '/alcoholReport',
         '/smsReport', '/kitchenTimesReport', '/saftUploadReport', '/transactionsReport',
         // Utbetalinger — where the owner finds VIVA's payouts; the VIVA login is the owner's, not staff's
         '/vivaPayoutReports',
         // Regnskapsbilag — VIVA's settlement with its fees: the owner's figures, for the owner and the accountant
         '/accountingVouchers',
         // Analytics
         '/analytics',
         // System
         // (the SUPER_ADMIN-only pages are refused earlier, for every role, by superAdminOnlyPaths)
       ];
       if (employeeRestrictedPaths.includes(to.path)) {
         next('/overview');
       } else {
         next();
       }
     } else if (user.userRole === 'ACCOUNTANT') {
       // ACCOUNTANT has read-only access: the Overview dashboard, viewing/downloading reports
       // (except X-report and SMS report), and the compliance support pages. Everything else
       // (write actions, settings, users, orders, products, regenerate/upload reports) is blocked.
       const accountantAllowedPaths = [
         '/', '/overview', '/analytics',
         '/z-report', '/totalSalesReport', '/alcoholReport',
         '/cashHoldingReport', '/saftReport',
         // Regnskapsbilag: VIVA's card settlement per day — read-only, and what the accountant comes for
         '/accountingVouchers',
         '/bokettersyn', '/terms', '/privacy', '/dpa',
         '/profile'
       ];
       if (accountantAllowedPaths.includes(to.path)) {
         next();
       } else {
         next('/overview');
       }
     } else {
       next();
     }
   } else {
     next();
   }
});

// Handle chunk loading errors (happens when a new version is deployed)
// This catches errors when navigating to lazy-loaded routes
router.onError((error) => {
   const isChunkLoadError = error.message.includes('Loading chunk') ||
                            error.message.includes('Failed to fetch dynamically imported module') ||
                            error.message.includes('Importing a module script failed');

   if (isChunkLoadError) {
      // Avoid infinite reload loops
      const lastReload = sessionStorage.getItem('chunk-error-reload');
      const now = Date.now();

      if (!lastReload || (now - parseInt(lastReload)) > 10000) {
         sessionStorage.setItem('chunk-error-reload', now.toString());
         window.location.reload();
      }
   }
});

export default router;
